export default __webpack_public_path__ + "static/media/t45.c313a48d.jpg";